export default __webpack_public_path__ + "img/Laurus_nobilis.073e8d5e.jpg";